import React from 'react';

const LogoSmall = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.556"
    height="29.194"
    viewBox="0 0 27.556 29.194"
  >
    <path
      className="a"
      d="M55.053,24.506a14.331,14.331,0,0,0,4.336-10.322,13.781,13.781,0,1,0-13.8,14.184,15.072,15.072,0,0,0,2.943-.309,15.5,15.5,0,0,1-3.626-3.975c-4.835-.284-8.867-4.754-8.867-9.91a9.565,9.565,0,0,1,19.122-.553c.005.184.005.369,0,.553a9.863,9.863,0,0,1-3.973,8.08A9.375,9.375,0,0,0,55.053,24.506Z"
      transform="translate(-31.833 -0.806)"
    />
    <path
      d="M57.286,30a13.97,13.97,0,0,1-13.8-13.848h4.178a9.574,9.574,0,0,0,9.53,9.618h.088Z"
      transform="translate(-31.833 -0.806)"
    />
  </svg>
);

export default LogoSmall;
